import React from 'react';
import services from '../data/services';

export default function Services() {
  return (
    <section className="py-12">
      <div className="bg-white rounded-2xl border border-[#e7e3cf] p-8 md:p-12 shadow-sm">
        <div className="text-center mb-10">
          <h3 className="text-2xl font-extrabold text-[#1b190d]">Our Services</h3>
          <div className="w-16 h-1 bg-primary mx-auto mt-2 rounded-full"></div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((s) => (
            <div key={s.id} className="trust-card flex flex-col items-center text-center space-y-3 group">
              <div className="size-16 rounded-full bg-primary/10 flex items-center justify-center group-hover:bg-primary transition-colors">
                <span className="material-symbols-outlined text-3xl text-primary group-hover:text-white">{s.icon}</span>
              </div>
              <h4 className="font-bold text-lg">{s.title}</h4>
              <p className="text-sm text-[#9a8d4c]">{s.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
